export default "__VITE_ASSET__714886b0__"